/**
 * Бейдж «І» — позначає запис, імпортований з іншої бази (1С/BAS).
 *
 * Універсальний маркер для будь-яких списків: показуй на початку рядка для
 * записів з external_source. Tooltip — «імпортовано з іншої бази».
 *
 * Використання:
 *   {row.external_source && <ImportedBadge />}
 * або у ag-grid cellRenderer.
 */
export default function ImportedBadge({ source }: { source?: string | null }) {
  if (source == null || source === '') return null;
  return (
    <span
      title="імпортовано з іншої бази"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 16,
        height: 16,
        borderRadius: 3,
        background: '#e0e7ff',
        color: '#3730a3',
        fontSize: '0.7rem',
        fontWeight: 700,
        lineHeight: 1,
        flexShrink: 0,
        cursor: 'help',
      }}
      aria-label="імпортовано з іншої бази"
    >
      І
    </span>
  );
}
